/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - 找不到页面",
  "ComingSoon": "即将推出",
  "YesanPersonalFinance": "Yesan, 个人理财",
  "Yesan": "Yesan",
  "PersonalFinance": "个人理财",
  "YesanDownload": "Yesan 下载",
  "ThisWebsiteUsesCookies": "我们使用 cookie 收集和分析有关网站性能和使用情况的信息，并提供社交媒体功能。继续使用即表示您同意我们的",
  "IGotIt": "确定",
  "BecomeFinanciallyFree": "实现财务自由",
  "inStepsAndActions": "8 个步骤和 3 项行动。",
  "TrackPlanAnalyze": "跟踪。计划。分析。",
  "FTrack": "1.跟踪",
  "FPlan": "2.计划",
  "FAnalyze": "3.分析",
  "Features": "功能介绍",
  "FeaturesSubHeading": "纯粹的初学者，已经具备财务知识，这是你实现财务自由所需的应用程序。",
  "ManageAccounts": "管理账户",
  "CashLiquidFixedAssetsLiabilities": "现金、流动资金、固定资产和负债。",
  "TrackTransactions": "跟踪交易",
  "IncomesExpensesTransferInvestments": "收入、支出、转账、投资。",
  "ImportExport": "导入/导出",
  "YourDataAlwaysAccessible": "随时访问您的数据。",
  "PlanYourFreedom": "规划您的自由",
  "StepsAwayFromFI": "实现财务独立的 8 个步骤。",
  "BudgetsAndGoals": "预算与目标",
  "CheckYourProgressAndAchieve": "检查进度，实现财务目标。",
  "DashboardAndAnalytics": "仪表盘与分析",
  "ReviewLearnOptimizeWith": "利用图表、洞察力和工具进行审查、学习和优化。",
  "Security": "安全性",
  "MilitaryGradeEncryption": "军用级加密，支持生物测量，数据存储在您的设备上。",
  "OfflineMode": "离线模式",
  "YourDataAlwaysAccessibleAndModif": "您的数据始终可访问和修改。",
  "Track": "跟踪",
  "Income": "收入",
  "Expense": "支出",
  "Transfer": "转账",
  "transactionsAndManageAccounts": "交易并管理各种账户：",
  "checkings": "支票账户",
  "savings": "储蓄账户",
  "realEstate": "房地产",
  "stocks": "股票市场",
  "bonds": "债券",
  "crypto": "加密货币",
  "notes": "纸币、现金钱包",
  "envelopes": "信封",
  "privateEquity": "私募股权",
  "metal": "金属",
  "retirement": "退休",
  "lifeInsurance": "人寿保险",
  "intellectualProperty": "知识产权",
  "otherLiquidAsset": "其他流动资产",
  "otherFixedAsset": "其他固定资产",
  "mortgage": "抵押贷款",
  "loan": "消费贷款",
  "creditCard": "信用卡",
  "otherLiability": "其他负债",
  "AccountsManagement": "账户管理",
  "MultipleAccountsTypesAndGrouping": "多种账户类型和分组",
  "LinkAccounts": "链接机构账户（仅适用于部分国家）",
  "SmartAccounts": "智能账户",
  "AddEditDeleteTransactions": "添加/编辑/删除交易",
  "TickVerifiedTransactions": "勾选已验证的交易",
  "CategorizeTransactions": "交易分类",
  "TagTransactions": "标记交易",
  "TrackKakeiboType": "跟踪 Kakeibo 类型",
  "TrackInvestments": "跟踪投资（仅在某些国家可用）",
  "ImportFromCSVFile": "从 CSV 文件完整或逐步导入交易",
  "ExportToCSVFile": "将交易导出至 CSV 文件",
  "stepsTowardsFIPlanBudgetingReachGoals": "实现财务独立的 8 个步骤计划，详细预算，更快实现您的财务目标。",
  "levelsTowardsFI": "实现财务独立的 8 个步骤",
  "EstablishBudgetsPer": "为每个",
  "account": "账户",
  "accountType": "账户类型",
  "KakeiboType": "Kakeibo 类型",
  "category": "类别",
  "tag": "标签",
  "label": "标签",
  "TrackBudgetsPerFrequency": "按频率跟踪预算",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "创建有关支出、余额、现金流和行动的目标",
  "TrackGoalsProgress": "跟踪目标进度",
  "ReviewLearnOptimizeWithReportsCharts": "利用报告、图表、趋势、洞察力和工具进行审查、学习和优化。",
  "Dashboard": "仪表板",
  "FSNetWorth": "财务报表：净资产",
  "FSPnL": "财务报表损益表",
  "FSBalanceSheetAssetsLiabilities": "财务报表资产负债表、资产、负债",
  "FSCashFlow": "财务报表现金流量表、借方贷方、流量",
  "FSFlows": "财务报表：流量",
  "FSRatios": "财务报表：比率",
  "TrendsMonthEnd": "月末趋势：收入与支出、现金流",
  "TrendsPerformance": "业绩趋势：同比、环比、同比",
  "IncomeTrendsPer": "人均收入趋势",
  "SpendingTrendsPer": "每笔支出趋势",
  "RecurringItemsIE": "经常性项目：收入与支出",
  "DebtProgressTrends": "债务进展趋势",
  "KakeiboMTDReviewTrends": "Kakeibo：MTD 回顾、上个月、趋势",
  "FIWCLE": "财务独立：挂图，按生命能量分列的支出",
  "DebtPaydownSnowballAvalanche": "债务偿还：滚雪球、雪崩",
  "FullyCustomizableAnalyticsRange": "完全自定义的分析时间范围",
  "ContactUs": "联系我们",
  "Privacy": "隐私条款",
  "Terms": "使用条款",
  "About": "关于隐私",
  "IAgreeToThe": "我同意",
  "AndThe": "和",
  "PrivacyPolicy": "隐私政策",
  "TermsOfUse": "使用条款",

  "DigitalSoftwareExperienceTagline": "现代世界的数字软件体验",
  "DigitalExperience": "数字体验",
  "SoftwareForTheModernWorld": "现代世界的软件",
  "MobileApplications": "移动应用程序",
  "forConnectedAndOfflineHumans": "适用于联网和离线人类",
  "CloudSaaS": "云 SaaS",
  "ResponsiveAndWebServices": "响应式服务和网络服务",
  "PersonalFinanceServices": "个人金融服务",
  "YS_p1": "Yesan 是一家充满活力的软件公司，专门为消费者开发尖端的移动应用程序。凭借对当今精通技术的用户不断变化的需求和偏好的敏锐理解，Yesan 致力于打造直观、引人入胜、功能丰富的移动体验，从而丰富用户的生活。",
  "YS_p2": "艺山的核心使命是坚持不懈地致力于创新和创造，每一款产品都经过精心打造，以提供无缝的功能和卓越的用户体验。",
  "PersonalFinanceApplication": "个人金融应用程序",
  "YPF_p1": "是山个人理财是一款先进的个人理财移动应用程序，旨在为用户提供全面的财务管理工具，方便用户随时随地使用。yesan.info个人理财 \"拥有时尚、直观的界面，为用户提供全面的财务管理方法，满足各种财务知识水平的用户需求。",
  "YPF_p2": "主要功能包括预算跟踪、支出分类和实时交易监控，让用户轻松了解自己的消费习惯。该应用程序还提供可定制的预算选项，使用户能够设定财务目标并跟踪其长期进展情况。",
  "YPF_p3": "此外，\"yesan.info个人理财 \"将安全放在首位，采用最先进的加密协议来保护用户的敏感财务信息。通过银行级别的安全措施，用户可以放心地链接他们的账户并同步交易，而不会泄露隐私。",
  "YPF_p4": "个人理财》超越了基本的预算编制，它提供了具有洞察力的分析和个性化建议，以优化财务决策。无论是识别潜在的储蓄机会、监控投资组合还是管理债务偿还策略，该应用都能提供量身定制的见解，帮助用户实现自己的财务目标。",
  "Discover": "发现",
  "Firstname": "名",
  "Lastname": "姓",
  "Company":"公司名称",
  "Subject": "主题",
  "Email": "电子邮件",
  "Message": "留言",
  "ThankYouForContactingUs": "感谢您与我们联系",
  "ValidFirstnameRequired": "必须填写有效的名。",
  "ValidLastnameRequired": "姓氏必须有效。",
  "ValidEmailAddressRequired": "请输入有效的电子邮件地址。",
  "ValidSubjectRequired": "请选择有效的主题。",
  "ValidMessageRequired": "请输入有效的信息。",
  "UnableToSendTheFormPleaseRetryLater": "无法发送表格，请稍后重试。",
  "Information": "信息",
  "Sales":"销售",
  "Support": "支持",
  "Press": "新闻",
  "Partnership": "合作伙伴",
  "Other": "其他",
  "Blog":"博客",

  "Accept":"接受",
  "Decline":"拒绝",

  "WorklogCalendar":"用于 Jira 的工作日志日历",

  "DirectlyAccessibleInProjectApps":"可在项目应用程序中直接访问",
  "VisualizeWhereYouSpentYourTime":"可视化您的时间使用情况",
  "AllYourWorklogsInACalendar":"日历中的所有工作日志",
  "MonthSummary":"月份摘要",
  "CheckIfYouForgotToLogTime":"检查是否忘记记录时间。",
  "DirectlyAccessTheIssuesAndUpdateTime":"直接访问问题并更新时间",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"点击工作日志项目，直接访问问题并编辑跟踪时间",
  "AlsoAvailableInDarkMode":"也可在黑暗模式下使用",
  "DirectlyLogWorkOnTheCalendarVisually":"直接在日历上直观地记录工作",
  "ClickOnTheCalendarToCreateNewWorklog":"点击日历创建新的工作日志",

  "AppsForAtlassian":"Atlassian 应用程序",
  "YCL_p1":"在日历上可视化所有工作日志，包括月、周、工作周、日视图。",
  "YCL_p2":"直接从日历中选择时间段记录工作。",
  "YCL_p3":"识别您是否忘记跟踪时间表的时间。",
  "YCL_p4":"语言版本 英语（英国）、英语（美国）、简体中文、繁体中文、捷克语、丹麦语、荷兰语、爱沙尼亚语、芬兰语、法语、德语、匈牙利语、冰岛语、意大利语、日语、韩语、挪威语、波兰语、葡萄牙语（巴西）、葡萄牙语（葡萄牙）、俄语、西班牙语、瑞典语、土耳其语。",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Jira 财务组合管理",
  "BringRealFinancialPortfolio":"为 Jira 带来真正的财务组合管理。在同一处跟踪预算、资本支出/运营支出以及项目成本。",
  "YFPAboutQ":"我们的 Jira 项目实际花费了多少？",
  "YFPAbout":"Jira 财务组合\n财务负责人和项目管理办公室（PMO）往往难以回答一个简单的问题：\n我们的 Jira 项目实际花费了多少？\nJira 用于跟踪工作进度。\n财务部门负责预算管理。\n这款应用终于将两者连接起来。\n\n财务组合将 Jira 转变为一个轻量级的项目组合管理（PPM）+ 财务规划平台——无需昂贵的企业级工具。",
  "YFPPorfolioQ":"组合预算与追踪",
  "YFPPorfolioP":"跨多个 Jira 项目创建组合，并定义：预算金额、货币、日期范围、包含的项目及团队。随着 Jira 中工作的推进，自动追踪实际成本。",
  "YFPPorfolioListQ":"投资组合",
  "YFPPorfolioListP":"创建整合多个 Jira 项目的财务投资组合，并即时查看：预算与实际成本对比、实时项目资金消耗率、资本支出与运营支出明细、每项任务及每个项目的成本，以及可导出的财务报告。所有数据均直接由 Jira 工作日志驱动。",
  "CostQ":"自动成本计算",
  "CostP":"将工时记录转化为真实的财务数据。该应用：读取 Jira 工时记录，应用小时费率，每日计算真实项目成本。无需电子表格，无需手动操作。",
  "RatesQ":"费率",
  "RatesP":"按项目、团队或全局设置小时费率",
  "ReportQ":"CSV 财务报表",
  "ReportP":"几秒钟内导出项目组合财务数据。特别适合：财务团队、CFO 报告、预算规划、审计支持",
  "SettingsQ":"资本性支出 (CapEx) 与运营性支出 (OpEx) 分类",
  "SettingsP":"支持会计和审计要求。将工作分类为：可资本化的开发 (CapEx)、运营性工作 (OpEx)。生成可供财务团队直接使用的可导出报告。"
};

export const documents = {
};
